/**
 * Solderstick Kit Builder & Appstle Subscription Controller
 * Fully Dynamic Version for Shopify Theme Customizer & Backend Data
 * Preserving all icons, HTML markup, and adding local state persistence
 */

var SS_CART_ICON_SVG = '<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.7875 8.55905H5.14548C4.89689 8.55905 4.67753 8.39672 4.60484 8.15895L2.45507 1.1307H0.565349C0.253115 1.1307 0 0.877582 0 0.565349C0 0.253115 0.253115 0 0.565349 0H2.87342C3.12202 0 3.34137 0.162336 3.41406 0.399944L5.56384 7.42836H11.4118L13.1216 3.3593H12.149C11.8368 3.3593 11.5837 3.10619 11.5837 2.79395C11.5837 2.48172 11.8368 2.2286 12.149 2.2286H13.9722C14.1615 2.2286 14.3384 2.32342 14.443 2.48107C14.5477 2.63872 14.5668 2.83837 14.4934 3.01298L12.3086 8.21274C12.2204 8.42256 12.0151 8.55905 11.7875 8.55905Z" fill="white"/> <path d="M4.66494 12.0291C5.21447 12.0291 5.65995 11.5836 5.65995 11.0341C5.65995 10.4845 5.21447 10.0391 4.66494 10.0391C4.1154 10.0391 3.66992 10.4845 3.66992 11.0341C3.66992 11.5836 4.1154 12.0291 4.66494 12.0291Z" fill="white"/> <path d="M12.0477 12.0291C12.5973 12.0291 13.0428 11.5836 13.0428 11.0341C13.0428 10.4845 12.5973 10.0391 12.0477 10.0391C11.4982 10.0391 11.0527 10.4845 11.0527 11.0341C11.0527 11.5836 11.4982 12.0291 12.0477 12.0291Z" fill="white"/> <path d="M10.0588 2.18709H8.43693V0.565349C8.43693 0.253115 8.18381 0 7.87158 0C7.55935 0 7.30623 0.253115 7.30623 0.565349V2.18709H5.68449C5.37225 2.18709 5.11914 2.44021 5.11914 2.75244C5.11914 3.06467 5.37225 3.31779 5.68449 3.31779H7.30623V4.93953C7.30623 5.25177 7.55935 5.50488 7.87158 5.50488C8.18381 5.50488 8.43693 5.25177 8.43693 4.93953V3.31779H10.0588C10.3711 3.31779 10.6242 3.06467 10.6242 2.75244C10.6242 2.44021 10.3711 2.18709 10.0588 2.18709Z" fill="white"/> </svg>';

class SolderstickKitBuilder {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.sectionId = this.section.dataset.sectionId || 'default';

    this.frequencies = {};
    this.selectedFreqId = null;
    this.kitItems = new Map(); // Key: card ID, Value: item object

    this.initDOM();
    this.initFrequencies();
    this.bindEvents();

    // Load persisted state if customer refreshed page or returned from checkout
    const hasRestored = this.loadState();
    if (!hasRestored) {
      this.initDefaultItems();
    }

    this.updateSummary();
  }

  initDOM() {
    this.freqCards = Array.from(this.section.querySelectorAll('.ss-freq-card'));
    this.tabBtns = Array.from(this.section.querySelectorAll('.ss-tab-btn'));
    this.searchInput = this.section.querySelector('.ss-search-input');
    this.productCards = Array.from(this.section.querySelectorAll('.ss-prod-card'));

    // Right panel summary elements
    this.summaryCountEl = this.section.querySelector('.ss-summary-count');
    this.summaryListEl = this.section.querySelector('.ss-summary-items-list');
    this.subtotalEl = this.section.querySelector('.ss-subtotal-val');
    this.savingsRowEl = this.section.querySelector('.ss-savings-row');
    this.savingsValEl = this.section.querySelector('.ss-savings-val');
    this.grandTotalEl = this.section.querySelector('.ss-grand-total-price');
    this.savingsPillTextEl = this.section.querySelector('.ss-savings-pill-text');
    this.scheduleHeaderEl = this.section.querySelector('.ss-schedule-header-text');
    this.checkoutBtn = this.section.querySelector('.ss-checkout-btn');
    this.checkoutBtnText = this.section.querySelector('.ss-checkout-btn-text');

    // Mobile sticky bottom bar elements
    this.mobileStickyBar = this.section.querySelector('.ss-mobile-sticky-bar');
    this.mobileBarCountEl = this.section.querySelector('.ss-mobile-bar-count');
    this.mobileBarPriceEl = this.section.querySelector('.ss-mobile-bar-price');
    this.mobileBarSavingsEl = this.section.querySelector('.ss-mobile-bar-savings');
    this.mobileCheckoutBtn = this.section.querySelector('.ss-mobile-checkout-btn');
  }

  initFrequencies() {
    this.freqCards.forEach(card => {
      const id = card.dataset.appstleId;
      if (!id) return;

      this.frequencies[id] = {
        id: id,
        name: card.dataset.name || 'Option',
        isSubscription: card.dataset.isSubscription === 'true',
        discountPercent: parseFloat(card.dataset.discountPercent || '0'),
        intervalText: card.dataset.intervalText || 'delivery'
      };

      if (card.classList.contains('selected') || !this.selectedFreqId) {
        this.selectedFreqId = id;
      }
    });

    if (!this.selectedFreqId && this.freqCards.length > 0) {
      this.selectedFreqId = this.freqCards[0].dataset.appstleId;
    }
  }

  bindEvents() {
    // Frequency selection
    this.freqCards.forEach(card => {
      card.addEventListener('click', () => {
        const id = card.dataset.appstleId;
        this.selectFrequency(id, card);
      });
    });

    // Category tabs
    this.tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this.tabBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        this.filterProducts();
      });
    });

    // Search input
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this.filterProducts());
    }

    // Product card actions
    this.productCards.forEach(card => {
      const addBtn = card.querySelector('.ss-add-btn');
      const qtyMinus = card.querySelector('.ss-qty-minus');
      const qtyPlus = card.querySelector('.ss-qty-plus');
      const qtyNum = card.querySelector('.ss-qty-num');
      const variantSelect = card.querySelector('.ss-variant-select');

      if (addBtn) {
        addBtn.addEventListener('click', () => {
          this.toggleProductItem(card);
        });
      }

      if (qtyMinus && qtyPlus && qtyNum) {
        qtyMinus.addEventListener('click', (e) => {
          e.stopPropagation();
          let q = parseInt(qtyNum.textContent, 10) || 1;
          if (q > 1) {
            q--;
            qtyNum.textContent = q;
            this.updateItemQuantityInKit(card, q);
          }
        });

        qtyPlus.addEventListener('click', (e) => {
          e.stopPropagation();
          let q = parseInt(qtyNum.textContent, 10) || 1;
          q++;
          qtyNum.textContent = q;
          this.updateItemQuantityInKit(card, q);
        });
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          this.updateItemVariantInKit(card);
        });
      }
    });

    // Main checkout CTA
    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleCheckoutSubmit();
      });
    }

    if (this.mobileCheckoutBtn) {
      this.mobileCheckoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.mobileCheckoutBtn.disabled) {
          this.handleCheckoutSubmit();
        }
      });
    }
  }

  /**
   * Initialize default items (Ensuring ALL default selected items start with quantity = 1)
   */
  initDefaultItems() {
    this.productCards.forEach(card => {
      const title = card.dataset.title || '';
      if (card.dataset.initAdded === 'true') {
        const variantSelect = card.querySelector('.ss-variant-select');
        const qtyNum = card.querySelector('.ss-qty-num');

        // Ensure default quantity displayed on card is 1
        if (qtyNum) {
          qtyNum.textContent = '1';
        }

        const selectedOpt = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
        const variantId = selectedOpt ? selectedOpt.value : card.dataset.defaultVariantId;
        const price = selectedOpt && selectedOpt.dataset.price ? parseFloat(selectedOpt.dataset.price) : parseFloat(card.dataset.price || 0);
        const qty = 1; // Default selected quantity is 1
        const img = card.dataset.img || '';

        this.kitItems.set(card.dataset.id, {
          card: card,
          id: card.dataset.id,
          variantId: variantId,
          title: title,
          price: price,
          quantity: qty,
          img: img
        });

        const addBtn = card.querySelector('.ss-add-btn');
        if (addBtn) {
          addBtn.classList.remove('primary');
          addBtn.classList.add('added');
          addBtn.innerHTML = '✓ ADDED TO KIT';
        }
      }
    });
  }

  selectFrequency(id, cardElement, shouldSave = true) {
    this.selectedFreqId = id;
    this.freqCards.forEach(c => {
      c.classList.remove('selected');
      const checkmark = c.querySelector('.ss-selected-checkmark');
      if (checkmark) checkmark.remove();
    });

    if (cardElement) {
      cardElement.classList.add('selected');
      const checkmark = document.createElement('div');
      checkmark.className = 'ss-selected-checkmark';
      checkmark.innerHTML = '✓';
      cardElement.appendChild(checkmark);
    }

    this.updateSummary(shouldSave);
  }

  filterProducts() {
    const activeTab = this.section.querySelector('.ss-tab-btn.active');
    const category = activeTab ? activeTab.dataset.category : 'all';
    const query = this.searchInput ? this.searchInput.value.toLowerCase().trim() : '';

    this.productCards.forEach(card => {
      const cardCats = (card.dataset.category || '').split(' ');
      const title = (card.dataset.title || '').toLowerCase();

      const matchesCat = (category === 'all' || cardCats.includes(category));
      const matchesSearch = (!query || title.includes(query));

      if (matchesCat && matchesSearch) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
  }

  toggleProductItem(card) {
    const id = card.dataset.id;
    const addBtn = card.querySelector('.ss-add-btn');

    if (this.kitItems.has(id)) {
      // Remove item
      this.kitItems.delete(id);
      if (addBtn) {
        addBtn.classList.remove('added');
        addBtn.classList.add('primary');
        addBtn.innerHTML = SS_CART_ICON_SVG + ' ADD TO KIT';
      }
    } else {
      // Add item
      const variantSelect = card.querySelector('.ss-variant-select');
      const qtyNum = card.querySelector('.ss-qty-num');
      const selectedOpt = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
      const variantId = selectedOpt ? selectedOpt.value : card.dataset.defaultVariantId;
      const price = selectedOpt && selectedOpt.dataset.price ? parseFloat(selectedOpt.dataset.price) : parseFloat(card.dataset.price || 0);
      const qty = qtyNum ? (parseInt(qtyNum.textContent, 10) || 1) : 1;
      const title = card.dataset.title || 'Connector Kit';
      const img = card.dataset.img || '';

      this.kitItems.set(id, {
        card: card,
        id: id,
        variantId: variantId,
        title: title,
        price: price,
        quantity: qty,
        img: img
      });

      if (addBtn) {
        addBtn.classList.remove('primary');
        addBtn.classList.add('added');
        addBtn.innerHTML = '✓ ADDED TO KIT';
      }
    }

    this.updateSummary();
  }

  updateItemQuantityInKit(card, newQty) {
    const id = card.dataset.id;
    if (this.kitItems.has(id)) {
      const item = this.kitItems.get(id);
      item.quantity = newQty;
      this.updateSummary();
    }
  }

  updateItemVariantInKit(card) {
    const id = card.dataset.id;
    const variantSelect = card.querySelector('.ss-variant-select');
    if (!variantSelect) return;

    const selectedOpt = variantSelect.options[variantSelect.selectedIndex];
    const newVariantId = selectedOpt.value;
    const newPrice = selectedOpt.dataset.price ? parseFloat(selectedOpt.dataset.price) : parseFloat(card.dataset.price || 0);

    this.updateCardPricing(card);

    if (this.kitItems.has(id)) {
      const item = this.kitItems.get(id);
      item.variantId = newVariantId;
      item.price = newPrice;
      this.updateSummary();
    }
  }

  /**
   * Sync the card's sale price, compare-at price and % OFF badge with the selected size
   */
  updateCardPricing(card) {
    const variantSelect = card.querySelector('.ss-variant-select');
    if (!variantSelect) return;
    const selectedOpt = variantSelect.options[variantSelect.selectedIndex];
    if (!selectedOpt) return;

    const price = selectedOpt.dataset.price ? parseFloat(selectedOpt.dataset.price) : parseFloat(card.dataset.price || 0);
    const compare = selectedOpt.dataset.comparePrice ? parseFloat(selectedOpt.dataset.comparePrice) : 0;

    const salePriceEl = card.querySelector('.ss-sale-price');
    const comparePriceEl = card.querySelector('.ss-compare-price');
    const discountTagEl = card.querySelector('.ss-discount-tag');

    if (salePriceEl) salePriceEl.textContent = `$${price.toFixed(2)}`;

    if (compare > price) {
      if (comparePriceEl) {
        comparePriceEl.textContent = `$${compare.toFixed(2)}`;
        comparePriceEl.style.display = '';
      }
      if (discountTagEl) {
        discountTagEl.textContent = `${Math.round(((compare - price) / compare) * 100)}% OFF`;
        discountTagEl.style.display = '';
      }
    } else {
      if (comparePriceEl) comparePriceEl.style.display = 'none';
      if (discountTagEl) discountTagEl.style.display = 'none';
    }
  }

  /**
   * Save selected state to localStorage for persistence across refresh and back navigation
   */
  saveState() {
    try {
      const itemsArray = [];
      this.kitItems.forEach((item, id) => {
        itemsArray.push({
          id: id,
          variantId: item.variantId,
          quantity: item.quantity
        });
      });

      const stateData = {
        selectedFreqId: this.selectedFreqId,
        items: itemsArray
      };

      localStorage.setItem(`solderstick_kit_state_v2_${this.sectionId}`, JSON.stringify(stateData));
    } catch (e) {
      console.warn('LocalStorage save error:', e);
    }
  }

  /**
   * Load persisted state from localStorage
   */
  loadState() {
    try {
      const raw = localStorage.getItem(`solderstick_kit_state_v2_${this.sectionId}`);
      if (!raw) return false;

      const stateData = JSON.parse(raw);
      if (!stateData || !Array.isArray(stateData.items)) return false;

      // Restore Frequency Selection
      if (stateData.selectedFreqId && this.frequencies[stateData.selectedFreqId]) {
        const targetCard = this.freqCards.find(c => c.dataset.appstleId === stateData.selectedFreqId);
        if (targetCard) {
          this.selectFrequency(stateData.selectedFreqId, targetCard, false);
        }
      }

      // Reset Kit Items
      this.kitItems.clear();
      this.productCards.forEach(card => {
        const addBtn = card.querySelector('.ss-add-btn');
        if (addBtn) {
          addBtn.classList.remove('added');
          addBtn.classList.add('primary');
          addBtn.innerHTML = SS_CART_ICON_SVG + ' ADD TO KIT';
        }
      });

      // Restore Saved Items
      stateData.items.forEach(savedItem => {
        const card = this.productCards.find(c => c.dataset.id === savedItem.id);
        if (card) {
          const qtyNum = card.querySelector('.ss-qty-num');
          if (qtyNum) qtyNum.textContent = savedItem.quantity || 1;

          const variantSelect = card.querySelector('.ss-variant-select');
          if (variantSelect && savedItem.variantId) {
            variantSelect.value = savedItem.variantId;
            this.updateCardPricing(card);
          }

          const selectedOpt = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
          const variantId = selectedOpt ? selectedOpt.value : card.dataset.defaultVariantId;
          const price = selectedOpt && selectedOpt.dataset.price ? parseFloat(selectedOpt.dataset.price) : parseFloat(card.dataset.price || 0);

          this.kitItems.set(card.dataset.id, {
            card: card,
            id: card.dataset.id,
            variantId: variantId,
            title: card.dataset.title || '',
            price: price,
            quantity: savedItem.quantity || 1,
            img: card.dataset.img || ''
          });

          const addBtn = card.querySelector('.ss-add-btn');
          if (addBtn) {
            addBtn.classList.remove('primary');
            addBtn.classList.add('added');
            addBtn.innerHTML = '✓ ADDED TO KIT';
          }
        }
      });

      return true;
    } catch (e) {
      console.warn('LocalStorage load error:', e);
      return false;
    }
  }

  updateSummary(shouldSave = true) {
    const freqInfo = this.frequencies[this.selectedFreqId] || { isSubscription: true, discountPercent: 15, intervalText: 'every 2 weeks' };
    let rawSubtotal = 0;
    let totalItems = 0;

    // Clear items list DOM
    if (this.summaryListEl) this.summaryListEl.innerHTML = '';

    this.kitItems.forEach((item, id) => {
      const itemTotalPrice = item.price * item.quantity;
      rawSubtotal += itemTotalPrice;
      totalItems += item.quantity;

      // Render summary card item with fully functional image tag & fallbacks
      if (this.summaryListEl) {
        const itemCard = document.createElement('div');
        itemCard.className = 'ss-summary-item-card';

        // Functional image src check
        const imgSrc = (item.img && item.img.trim() !== '') ? item.img : 'https://cdn.shopify.com/s/files/1/0533/2089/8727/files/placeholder-connectors-1.jpg?v=1680000000';

        itemCard.innerHTML = `
          <img src="${imgSrc}" class="ss-item-thumb" alt="${this.escapeHtml(item.title)}" onError="this.style.opacity='0.3'" />
          <div class="ss-item-info">
            <div class="ss-item-name">${this.escapeHtml(item.title)} x ${item.quantity}</div>
            <div class="ss-item-price">$${itemTotalPrice.toFixed(2)}</div>
          </div>
          <button type="button" class="ss-item-remove-btn" data-id="${id}" title="Remove item" aria-label="Remove ${this.escapeHtml(item.title)}"> <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.2995 1.6101e-05H9.11733C9.29767 -0.000100566 9.45475 -0.000200475 9.60308 0.0234912C10.1892 0.117083 10.6963 0.482624 10.9705 1.00903C11.0398 1.14227 11.0894 1.29134 11.1463 1.46245L11.2394 1.74153C11.2552 1.78877 11.2597 1.80215 11.2634 1.81268C11.4094 2.21612 11.7878 2.48883 12.2166 2.4997C12.2279 2.49998 12.2417 2.50003 12.2917 2.50003H14.7917C15.1369 2.50003 15.4167 2.77986 15.4167 3.12503C15.4167 3.47021 15.1369 3.75003 14.7917 3.75003H0.625C0.279825 3.75003 0 3.47021 0 3.12503C0 2.77986 0.279825 2.50003 0.625 2.50003H3.12507C3.17511 2.50003 3.18892 2.49998 3.20019 2.4997C3.62907 2.48883 4.00743 2.21613 4.15335 1.8127C4.15719 1.8021 4.1616 1.78901 4.17742 1.74153L4.27043 1.46247C4.32734 1.29137 4.37694 1.14227 4.44633 1.00903C4.72044 0.482624 5.22761 0.117083 5.81369 0.0234912C5.96204 -0.000200475 6.11917 -0.000100566 6.2995 1.6101e-05ZM5.21513 2.50003C5.25805 2.41585 5.29609 2.32837 5.32882 2.2379C5.33875 2.21043 5.3485 2.18118 5.36102 2.14362L5.44418 1.89411C5.52016 1.66618 5.53766 1.61969 5.55501 1.58637C5.64638 1.4109 5.81544 1.28905 6.0108 1.25785C6.04792 1.25192 6.0975 1.25003 6.33775 1.25003H9.079C9.31925 1.25003 9.36892 1.25192 9.406 1.25785C9.60133 1.28905 9.77042 1.4109 9.86183 1.58637C9.87917 1.61969 9.89667 1.66617 9.97258 1.89411L10.0557 2.14347L10.088 2.23792C10.1208 2.32838 10.1587 2.41585 10.2017 2.50003H5.21513Z" fill="#FD3F00"/> <path d="M2.63731 5.16939C2.61435 4.82497 2.31654 4.56439 1.97212 4.58735C1.62771 4.6103 1.36712 4.90812 1.39008 5.25254L1.77629 11.0456C1.84754 12.1146 1.90509 12.978 2.04006 13.6556C2.1804 14.36 2.41908 14.9485 2.91207 15.4096C3.40507 15.8709 4.00803 16.0699 4.72024 16.163C5.40525 16.2526 6.27057 16.2526 7.34191 16.2526H8.07432C9.14565 16.2526 10.011 16.2526 10.6961 16.163C11.4082 16.0699 12.0112 15.8709 12.5042 15.4096C12.9972 14.9485 13.2359 14.36 13.3762 13.6556C13.5112 12.978 13.5687 12.1146 13.64 11.0456L14.0262 5.25254C14.0492 4.90812 13.7886 4.6103 13.4442 4.58735C13.0997 4.56439 12.8019 4.82497 12.779 5.16939L12.3957 10.9186C12.3208 12.0419 12.2675 12.8234 12.1503 13.4114C12.0367 13.9818 11.8781 14.2837 11.6502 14.4969C11.4224 14.71 11.1106 14.8482 10.5339 14.9236C9.9394 15.0014 9.15607 15.0026 8.0304 15.0026H7.38591C6.26024 15.0026 5.47686 15.0014 4.88236 14.9236C4.3057 14.8482 3.9939 14.71 3.76605 14.4969C3.53821 14.2837 3.3796 13.9818 3.26597 13.4114C3.14884 12.8234 3.09548 12.0419 3.0206 10.9186L2.63731 5.16939Z" fill="#FD3F00"/> <path d="M5.56286 6.66721C5.90632 6.63288 6.21264 6.88346 6.24697 7.22696L6.66364 11.3936C6.69797 11.737 6.44739 12.0434 6.10389 12.0777C5.76044 12.112 5.45416 11.8615 5.41981 11.518L5.00315 7.35129C4.96881 7.00788 5.2194 6.70154 5.56286 6.66721Z" fill="#FD3F00"/> <path d="M9.8539 6.66721C10.1974 6.70154 10.448 7.00788 10.4136 7.35129L9.99698 11.518C9.96265 11.8615 9.65631 12.112 9.3129 12.0777C8.9694 12.0434 8.71881 11.737 8.75315 11.3936L9.16981 7.22696C9.20415 6.88346 9.51048 6.63288 9.8539 6.66721Z" fill="#FD3F00"/> </svg> </button>
        `;

        itemCard.querySelector('.ss-item-remove-btn').addEventListener('click', () => {
          this.toggleProductItem(item.card);
        });

        this.summaryListEl.appendChild(itemCard);
      }
    });

    if (this.summaryListEl && this.kitItems.size === 0) {
      this.summaryListEl.innerHTML = '<div class="ss-summary-empty" style="padding:24px 12px;text-align:center;color:#64748b;font-size:14px;line-height:1.5;">Your kit is empty.<br>Add connectors from the list to start saving.</div>';
    }

    if (this.summaryCountEl) {
      this.summaryCountEl.textContent = `${totalItems} ${totalItems === 1 ? 'Item' : 'Items'}`;
    }

    // Calculate discount & totals
    const discountAmount = freqInfo.isSubscription ? (rawSubtotal * (freqInfo.discountPercent / 100)) : 0;
    const finalTotal = Math.max(0, rawSubtotal - discountAmount);

    if (this.subtotalEl) this.subtotalEl.textContent = `$${rawSubtotal.toFixed(2)}`;

    if (this.savingsRowEl && this.savingsValEl) {
      if (discountAmount > 0) {
        this.savingsRowEl.style.display = 'flex';
        this.savingsValEl.textContent = `-$${discountAmount.toFixed(2)}`;
      } else {
        this.savingsRowEl.style.display = 'none';
      }
    }

    if (this.grandTotalEl) this.grandTotalEl.textContent = `$${finalTotal.toFixed(2)}`;

    // Update Green Savings Callout Pill
    if (this.savingsPillTextEl) {
      if (freqInfo.isSubscription) {
        const intervalDays = this.getIntervalDays(freqInfo.intervalText);
        const yearlySavings = Math.round(discountAmount * (365 / intervalDays));
        if (discountAmount > 0) {
          this.savingsPillTextEl.textContent = `✓ You save $${discountAmount.toFixed(0)} every delivery - $${yearlySavings} a year`;
        } else {
          this.savingsPillTextEl.textContent = `Add items to save ${freqInfo.discountPercent}% on every delivery`;
        }
      } else {
        this.savingsPillTextEl.textContent = `Select a subscription frequency to save up to 25%!`;
      }
    }

    // Dynamic Renewal Schedule Pill
    if (this.scheduleHeaderEl) {
      if (freqInfo.isSubscription) {
        const renewDate = this.calculateRenewalDate(freqInfo.intervalText);
        this.scheduleHeaderEl.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0799/2272/4964/files/Group_9.svg?v=1788386635"/> Renews ${renewDate}, then ${freqInfo.intervalText}`;
      } else {
        this.scheduleHeaderEl.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0799/2272/4964/files/svgviewer-output_2.svg?v=1788386565"/> One-Time Delivery (No Renewal)`;
      }
    }

    // Update CTA Button Label
    if (this.checkoutBtnText) {
      if (freqInfo.isSubscription) {
        this.checkoutBtnText.textContent = this.section.dataset.subscribeCtaText || 'START MY KIT SUBSCRIPTION';
      } else {
        this.checkoutBtnText.textContent = this.section.dataset.onetimeCtaText || 'BUY ONE-TIME KIT';
      }
    }

    // Update Mobile Sticky Bottom Bar
    if (this.mobileStickyBar) {
      const intervalDesc = freqInfo.isSubscription ? (freqInfo.intervalText || 'every period') : 'one-time';
      if (totalItems > 0) {
        if (this.mobileBarCountEl) {
          this.mobileBarCountEl.textContent = `${totalItems} ${totalItems === 1 ? 'item' : 'items'} · ${intervalDesc}`;
        }
        if (this.mobileBarPriceEl) {
          this.mobileBarPriceEl.textContent = `$${finalTotal.toFixed(2)}`;
        }
        if (this.mobileBarSavingsEl) {
          if (discountAmount > 0) {
            this.mobileBarSavingsEl.style.display = 'inline';
            this.mobileBarSavingsEl.textContent = `save $${discountAmount.toFixed(2)}`;
          } else {
            this.mobileBarSavingsEl.style.display = 'none';
          }
        }
        if (this.mobileCheckoutBtn) {
          this.mobileCheckoutBtn.disabled = false;
          this.mobileCheckoutBtn.classList.remove('disabled');
        }
      } else {
        if (this.mobileBarCountEl) {
          this.mobileBarCountEl.textContent = 'Your delivery is empty';
        }
        if (this.mobileBarPriceEl) {
          this.mobileBarPriceEl.textContent = '$0';
        }
        if (this.mobileBarSavingsEl) {
          this.mobileBarSavingsEl.style.display = 'none';
        }
        if (this.mobileCheckoutBtn) {
          this.mobileCheckoutBtn.disabled = true;
          this.mobileCheckoutBtn.classList.add('disabled');
        }
      }
    }

    // Persist state to LocalStorage
    if (shouldSave) {
      this.saveState();
    }
  }

  getIntervalDays(intervalText) {
    const match = String(intervalText || '').match(/(\d+)\s*week/i);
    return match ? parseInt(match[1], 10) * 7 : 14;
  }

  calculateRenewalDate(intervalText) {
    const now = new Date();
    const daysToAdd = this.getIntervalDays(intervalText);

    now.setDate(now.getDate() + daysToAdd);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${now.getDate()} ${months[now.getMonth()]}`;
  }

  async handleCheckoutSubmit() {
    if (this.kitItems.size === 0) {
      alert('Please add at least one connector kit item to your bundle!');
      return;
    }

    this.checkoutBtn.classList.add('loading');
    const itemsPayload = [];

    this.kitItems.forEach(item => {
      const payloadObj = {
        id: parseInt(item.variantId, 10),
        quantity: item.quantity
      };

      if (this.selectedFreqId && this.frequencies[this.selectedFreqId] && this.frequencies[this.selectedFreqId].isSubscription) {
        payloadObj.selling_plan = parseInt(this.selectedFreqId, 10);
      }

      itemsPayload.push(payloadObj);
    });

    console.log('Submitting Appstle Cart Payload:', itemsPayload);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsPayload })
      });

      if (response.ok) {
        window.location.href = '/checkout';
      } else {
        const err = await response.json();
        alert(err.description || 'Error submitting kit subscription to cart.');
      }
    } catch (e) {
      console.error('Submission Error:', e);
      window.location.href = '/cart';
    } finally {
      this.checkoutBtn.classList.remove('loading');
    }
  }

  escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ss-kit-section').forEach(sec => {
    new SolderstickKitBuilder(sec);
  });
});
